export type ImageItem = {
  id: string;
  fileName: string;
  url: string;
  fileType: string;
  importId: string;
  fileBlobName?: string;
};

export type PromotionImageItem = {
  _id: string;
  name: string;
  image: ImageItem;
  createdAt?: Date | null;
  createdBy?: string | null;
  updatedAt?: Date | null;
  updatedBy?: string | null;
};

export type PromotionImageDetail = {
  _id?: string;
  name: string;
  image: ImageItem;
};

export enum PromotionImageFormMode {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
}

export type PromotionImageListParams = {
  name: string;
  page: number;
  limit: number;
};

export type PromotionImageCreateReponse = {
  tag: string;
  code: number;
  message: string;
  duplicateKeys: string[];
  errorCode: string;
};

export enum PromotionImageErrorMessage {
  SPECIAL_CHARACTERS = 'Name does not include special characters',
  DUPLICATE_NAME = 'Name must not have the same name as a previously uploaded image or an image awaiting upload/input',
  OVER_LIMIT = 'Promotion images over 600',
  DUPLICATE_NAME_ALERT = 'Promotion image already existed',
  SOMETHING_WRONG = 'Something went wrong',
}
